<img src="../../assets/images/news/{{article.imageURL}}" />
<h2 class="heading">{{article.name}}</h2>
<div class="description-text">{{article.description}}</div>
<a href="{{article.link}}"><button mat-raised-button color="accent" ngClass.lt-md="full-width">View</button></a>
